/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{glsl as o}from"../../shaderModules/glsl.js";const s=o`vec4(0.0, 0.0, 2.0, 1.0)`;export{s as positionOutsideClipSpace};
